module.exports = {
    template: `<b><slot></slot></b>`
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/parsed/property-code.js